module.exports = "if (_active < 0.5) {\ngl_Position = vec4(0.0, 0.0, 0.0, 1.0);\nreturn;\n}"